import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const useProgramStore = defineStore('program', () => {
    const all = ref({ data: [] });

    const reset = () => {
        all.value = { data: [] };
    };

    const actions = {
        search: (params) => axios.get('/api/v1/programs', { params }),
        store: (params) => axios.post('/api/v1/programs', params),
        update: (params) => axios.patch('/api/v1/programs/' + params.hash, params),
        destroy: (params) => axios.delete('/api/v1/programs/' + params.hash),
        createBlankProgram: () => axios.post('/api/v1/programs/blank'),
        copy: (params) => axios.post('/api/v1/programs/' + params.hash + '/copy', params),
    };

    return {
        all,
        reset,
        ...actions,
    };
});
